import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getHistoryList = (params) => {
    return axios.get(`${backendHost}/api/admin/history/list`, {params});
};

export {
    getHistoryList
}